import React, { useRef, useState } from 'react';
import { Alert, Button, Image, Space } from 'antd';
import { SaleResource } from '../../services/saleLinks';
import { useSaleText } from './saleUi';

export const resolveSaleHtmlIframeUrl = (resourceUrl: string, pageHostname: string): string => {
  if (pageHostname.toLowerCase() !== 'tuchuangyun.cn') return resourceUrl;
  try {
    const iframeUrl = new URL(resourceUrl);
    if (!iframeUrl.pathname.startsWith('/autoupload/')) return resourceUrl;
    iframeUrl.hostname = 'tuchuangyun.cn';
    return iframeUrl.toString();
  } catch {
    return resourceUrl;
  }
};

/** URL is obtained only after authorization; no browser secret reaches embedded content. */
const SaleResourceView: React.FC<{ resource: SaleResource; immersiveHtml?: boolean }> = ({ resource, immersiveHtml = false }) => {
  const text = useSaleText();
  const frame = useRef<HTMLIFrameElement>(null);
  const [failed, setFailed] = useState(false);
  let uri: URL;
  try { uri = new URL(resource.url); } catch { return <Alert type="error" message={text('资源地址无效', 'Invalid resource URL')} />; }
  const iframeUrl = resource.category === 'html'
    ? resolveSaleHtmlIframeUrl(resource.url, window.location.hostname)
    : resource.url;
  let iframeUri: URL;
  try { iframeUri = new URL(iframeUrl); } catch { iframeUri = uri; }
  const safe = iframeUri.protocol === 'https:' && !iframeUri.username && !iframeUri.password;
  if (!safe) {
    return <Alert type="error" message={text('资源无法在此页面安全展示。', 'This resource cannot be displayed here.')} />;
  }
  if (resource.category === 'html' && immersiveHtml) {
    return <iframe
      ref={frame}
      title={resource.fileName}
      src={iframeUrl}
      referrerPolicy="no-referrer"
      allowFullScreen
      className="sale-html-fullscreen-frame"
    />;
  }
  return <div className="sale-resource">
    <Space wrap className="sale-toolbar">
      <Button href={resource.url} target="_blank" rel="noopener noreferrer">
        {text('新窗口打开 / 下载', 'Open / download')}
      </Button>
      {resource.category === 'html' && <Button onClick={() => void frame.current?.requestFullscreen?.().catch(() => undefined)}>
        {text('全屏', 'Full screen')}
      </Button>}
    </Space>
    {failed && <Alert type="warning" message={text('资源加载失败，请尝试新窗口打开或联系卖家。', 'Loading failed. Open in a new window or contact the seller.')} />}
    {resource.category === 'html' && <>
      <Alert type="info" message={text('若网页无法在此处显示，请使用“新窗口打开”。', 'If the page cannot be embedded, use Open in a new window.')} />
      <iframe ref={frame} title={resource.fileName} src={iframeUrl}
        referrerPolicy="no-referrer" allowFullScreen className="sale-frame" />
    </>}
    {resource.category === 'image' && <Image src={resource.url} alt={resource.fileName} onError={() => setFailed(true)} />}
    {resource.category === 'video' && <video aria-label={resource.fileName} src={resource.url} controls playsInline preload="metadata" onError={() => setFailed(true)} />}
    {resource.category === 'audio' && <audio aria-label={resource.fileName} src={resource.url} controls preload="metadata" onError={() => setFailed(true)} />}
  </div>;
};
export default SaleResourceView;
